<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="col-12 d-flex mt-3 justify-content">
      <div class="col d-flex align-items-center">
        <h1 class="fs-4 fw-bold text-primary-color my-0">Domínio</h1>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mb-4 mt-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <div #contratoContainer>
          <form [formGroup]="dominiosFilterForm" id="dominiosFilterForm">
            <div class="row g-4 mb-2">
              <div class="form-group">
                <label for="nome" class="form-label">Nome</label>
                <input nz-input placeholder="Nome" [nzSize]="size" name="nome" formControlName="nome" />
              </div>
            </div>
            <div class="form-group d-flex justify-content-end ml-3">
              <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4"
                form="dominiosFilterForm" (click)="pesquisar()">
                Pesquisar
              </button>
            </div>
          </form>

          <nz-divider class="m-0 p-0 mt-4"></nz-divider>

          <div class="d-flex flex-column page-content border border-radius w-100">
            <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
              (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate">
              <thead>
                <tr>
                  <th nzColumnKey="nome" nzShowSort [nzSortFn]="true" style="min-width: 50px; max-width: 400px;">
                    Nome
                  </th>
                  <th nzColumnKey="descricao" nzShowSort [nzSortFn]="true">Descricao</th>
                  <th class="text-center" nzFixed="right" style="width: 80px;">
                    Ações
                  </th>                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="paginator?.paginaAtual">
                  <tr *ngFor="let item of dataSet">
                    <td style="white-space: normal; word-break: break-word; max-width: 400px;"> 
                      {{ item.nome == 'Grupo' ? 'Grupo de Correspondência' : item.nome }}
                    </td>
                    <td>{{ item.descricao}}</td>
                   <td class="text-center" nzFixed="right" style="width: 80px;">
                      <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                        <span nz-icon nzType="more" nzTheme="outline"></span>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <li nz-menu-item type="button" (click)="accessarDominio(item)">
                            <a> Acessar </a>
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
            <ng-template #footerTemplate>
              <section class="d-flex justify-content-end w-100">
                <app-pagination [itemPorPagina]="10"></app-pagination>
              </section>
            </ng-template>
            <ng-template #semDadosTemplate>
              <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
                <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-end align-items-center mt-3">
          <ng-template *ngxPermissionsOnly="[perfilEnum.Administrador, perfilEnum.Validador]">
            <eds-popover class="menu-exportar-actions" targetClass="exportar-actions" position="bottom">
              <td class="text-center">
                <button nz-button nz-dropdown [nzDropdownMenu]="menu" nzType="primary" [nzSize]="size" nzShape="circle">
                  <span nz-icon nzType="download"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </eds-popover>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>
